'use strict';

var React = require('react');
var cn = require('../cn.js');

function _interopDefaultCompat (e) { return e && typeof e === 'object' && 'default' in e ? e : { default: e }; }

var React__default = /*#__PURE__*/_interopDefaultCompat(React);

/**
 * Компонент задающий тему для своих дочерних компонентов.
 */
var ThemeProvider = function (_a) {
    var theme = _a.theme, children = _a.children;
    return (React__default.default.createElement(cn.ThemeProvider, { value: theme }, children));
};

module.exports = ThemeProvider;
